<onsip-header-main>
  <onsip-header-page-title>{{
    "ONSIP_I18N.ANNOUNCEMENT_SETUP" | translate
  }}</onsip-header-page-title>
</onsip-header-main>
<div class="mat-body-2 pricing-text">
  {{ pricingText }}
</div>
<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form
    onsipFormTracking
    [formGroup]="announcementInfo"
    name="adv-announcement-setup-wizard"
    id="adv-announcement-setup-wizard"
    (ngSubmit)="submit()"
  >
    <mat-horizontal-stepper
      #stepper
      linear
      class="onsip-stepper-disabled-header onsip-header-full-width"
    >
      <mat-step #basicStep completed="false">
        <ng-template matStepLabel>
          @if ((lessThanMediumBreakpoint | async) === false) {
          <span>{{ "ONSIP_I18N.BASIC_SETTINGS" | translate }}</span>
          }
        </ng-template>
        <ng-container>
          <div class="mat-headline-5">
            {{ "ONSIP_I18N.BASIC_ANNOUNCEMENT_SETTINGS" | translate }}
          </div>
          <ng-template *ngTemplateOutlet="announcementBasicForm"></ng-template>
          <span class="navigation-buttons no-back">
            <button
              mat-button
              type="button"
              color="primary"
              class="cancel-button right-buttons"
              (click)="handleCancel()"
            >
              {{ "ONSIP_I18N.CANCEL" | translate }}
            </button>
            <button
              type="button"
              mat-flat-button
              color="primary"
              class="right-buttons"
              (click)="nextStep()"
              [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_ADD_NEXT_STEP"
            >
              {{ "ONSIP_I18N.NEXT" | translate }}
            </button>
          </span>
        </ng-container>
      </mat-step>
      <mat-step #customStep completed="false">
        <ng-template matStepLabel>
          @if ((lessThanMediumBreakpoint | async) === false) {
          <span>{{ "ONSIP_I18N.CUSTOM_ANNOUNCEMENT" | translate }}</span>
          }
        </ng-template>
        <ng-container>
          <div class="mat-headline-5">{{ "ONSIP_I18N.CUSTOM_ANNOUNCEMENT" | translate }}</div>
          <ng-template *ngTemplateOutlet="announcementCustomForm"></ng-template>
          @if ((mobileBreakpoint | async) === false) {
          <div class="navigation-buttons">
            <button type="button" mat-stroked-button color="primary" (click)="backStep()">
              {{ "ONSIP_I18N.BACK" | translate }}
            </button>
            <span>
              <button
                mat-button
                type="button"
                color="primary"
                class="cancel-button right-buttons"
                (click)="handleCancel()"
              >
                {{ "ONSIP_I18N.CANCEL" | translate }}
              </button>
              <button
                type="button"
                mat-flat-button
                color="primary"
                class="right-buttons"
                (click)="nextStep(true)"
                [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_ADD_GO_REVIEW"
              >
                {{ "ONSIP_I18N.NEXT" | translate }}
              </button>
            </span>
          </div>
          } @if (mobileBreakpoint | async) {
          <div class="navigation-mobile-buttons">
            <button
              type="button"
              mat-flat-button
              color="primary"
              (click)="nextStep(true)"
              [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_ADD_GO_REVIEW"
            >
              {{ "ONSIP_I18N.NEXT" | translate }}
            </button>
            <button type="button" mat-stroked-button color="primary" (click)="backStep()">
              {{ "ONSIP_I18N.BACK" | translate }}
            </button>
            <button mat-button type="button" color="primary" (click)="handleCancel()">
              {{ "ONSIP_I18N.CANCEL" | translate }}
            </button>
          </div>
          }
        </ng-container>
      </mat-step>
      <mat-step #reviewStep>
        <ng-template matStepLabel>
          @if ((lessThanMediumBreakpoint | async) === false) {
          <span>{{ "ONSIP_I18N.REVIEW" | translate }}</span>
          }
        </ng-template>
        @if (stepper.selected === reviewStep) {
        <span class="review-header">
          <div class="mat-headline-5">{{ "ONSIP_I18N.REVIEW" | translate }}</div>
          <button
            type="button"
            class="edit-info-button"
            mat-stroked-button
            color="primary"
            (click)="showEditPanel ? toggleEditPanel(true) : toggleEditPanel()"
          >
            {{ showEditPanel ? "Cancel edits" : "Edit info" }}
          </button>
        </span>
        <div class="review-container">
          <div class="review-basic-container">
            <div class="mat-headline-6">
              {{ "ONSIP_I18N.BASIC_ANNOUNCEMENT_SETTINGS" | translate }}
            </div>
            <div class="review-view-container onsip-grid-placement">
              @if (!showEditPanel) {
              <div class="column-1">
                <div class="review-property">
                  <div class="mat-body-1">{{ "ONSIP_I18N.ANNOUNCEMENT_NAME" | translate }}</div>
                  <div [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_ADD_REVIEW_NAME">
                    {{ announcementInfo.controls.announcementName.value || "n/a" }}
                  </div>
                </div>
                <div class="review-property">
                  <div class="mat-body-1">{{ "ONSIP_I18N.TRANSFER_TO" | translate }}</div>
                  <div>{{ transferToText }}</div>
                </div>
                <div class="review-property">
                  <div class="mat-body-1">SIP address</div>
                  <div>{{ announcementInfo.controls.sipAddress.value }}&#64;{{ this.domain }}</div>
                </div>
                <div class="review-property">
                  <div class="mat-body-1">Extensions</div>
                  @if (announcementInfo.controls.extensions.value.length) {
                  <div [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_ADD_REVIEW_EXTENSIONS">
                    @for (extension of announcementInfo.controls.extensions.value; track extension)
                    {
                    <div>
                      {{ extension | formatExtensions }}
                    </div>
                    }
                  </div>
                  } @else { No extensions added }
                </div>
                <div class="review-property">
                  <div class="mat-body-1">Phone numbers</div>
                  @if (phonesList.length) {
                  <div [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_ADD_REVIEW_PHONES">
                    @for (did of phonesList; track did) {
                    <div>{{ did | e164 }}</div>
                    }
                  </div>
                  } @else { No phone numbers added }
                </div>
                <div>
                  <div class="mat-headline-6">
                    {{ "ONSIP_I18N.CUSTOM_ANNOUNCEMENT" | translate }}
                  </div>
                  @if (!sanitizedAudioFile) {
                  <div>
                    <div>
                      {{ "ONSIP_I18N.THIS_ANNOUNCEMENT_HAS_NO_CUSTOM_RECORDING" | translate }}
                    </div>
                    <div>
                      {{
                        "ONSIP_I18N.CLICK_EDIT_INFO_BUTTON_TO_UPLOAD_A_PRERECORDED_FILE_WAV_OR_RECORD_A_RECORDING_HERE"
                          | translate
                      }}
                    </div>
                  </div>
                  } @if (!!sanitizedAudioFile) {
                  <div>
                    <div class="mat-body-1 review-recording-view-element">
                      {{ "ONSIP_I18N.CURRENT_ANNOUNCEMENT" | translate }}
                    </div>
                    <div class="review-recording-view-element">
                      {{ announcementInfo.controls.record.value?.name }}
                    </div>
                    <div class="announcements-recording-audio-container">
                      <audio
                        #messageAudio
                        class="announcement-message"
                        [attr.src]="sanitizedAudioFile ? sanitizedAudioFile : ''"
                        controls
                        controlsList="nodownload"
                      ></audio>
                      <div class="recording-download-button">
                        <a
                          id="announcement-recording-download"
                          [href]="sanitizedAudioFile ? sanitizedAudioFile : ''"
                          download
                          type="audio/wav"
                        >
                          <mat-icon class="recording-download-icon" aria-label="file_download"
                            >file_download</mat-icon
                          >
                        </a>
                      </div>
                    </div>
                  </div>
                  }
                </div>
              </div>
              }
              <div class="review-edit-subsection">
                @if (showEditPanel) {
                <div class="column-1">
                  <ng-container>
                    <ng-template
                      *ngTemplateOutlet="
                        announcementBasicForm;
                        context: { $implicit: 'one-column' }
                      "
                    ></ng-template>
                    <div class="mat-headline-6">
                      {{ "ONSIP_I18N.CUSTOM_ANNOUNCEMENT" | translate }}
                    </div>
                    <ng-template
                      *ngTemplateOutlet="
                        announcementCustomForm;
                        context: { $implicit: 'one-column' }
                      "
                    ></ng-template>
                  </ng-container>
                </div>
                }
              </div>
            </div>
          </div>
          @if ((mobileBreakpoint | async) === false) {
          <div class="navigation-buttons">
            <button type="button" mat-stroked-button color="primary" (click)="backStep()">
              {{ "ONSIP_I18N.BACK" | translate }}
            </button>
            @if (!showEditPanel) {
            <span>
              <button
                mat-button
                type="button"
                color="primary"
                class="cancel-button right-buttons"
                (click)="handleCancel()"
              >
                {{ "ONSIP_I18N.CANCEL" | translate }}
              </button>
              <button
                type="submit"
                mat-flat-button
                color="primary"
                class="right-buttons"
                matStepperNext
                [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_ADD_SUBMIT"
              >
                {{ "ONSIP_I18N.SAVE__FINISH_SETUP" | translate }}
              </button>
            </span>
            } @if (showEditPanel) {
            <span>
              <button
                mat-button
                type="button"
                color="primary"
                class="cancel-button right-buttons"
                (click)="handleCancel()"
              >
                {{ "ONSIP_I18N.CANCEL" | translate }}
              </button>
              <button
                type="button"
                mat-flat-button
                color="primary"
                class="right-buttons"
                (click)="toggleEditPanel()"
              >
                {{ "ONSIP_I18N.REVIEW_AND_SUBMIT" | translate }}
              </button>
            </span>
            }
          </div>
          } @if ((mobileBreakpoint | async) && !showEditPanel) {
          <div class="navigation-mobile-buttons">
            <button
              type="submit"
              mat-flat-button
              color="primary"
              matStepperNext
              [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_ADD_SUBMIT"
            >
              {{ "ONSIP_I18N.SAVE__FINISH_SETUP" | translate }}
            </button>
            <button type="button" mat-stroked-button color="primary" (click)="backStep()">
              {{ "ONSIP_I18N.BACK" | translate }}
            </button>
            <button mat-button type="button" color="primary" (click)="handleCancel()">
              {{ "ONSIP_I18N.CANCEL" | translate }}
            </button>
          </div>
          } @if ((mobileBreakpoint | async) && showEditPanel) {
          <div class="navigation-mobile-buttons">
            <button type="button" mat-flat-button color="primary" (click)="toggleEditPanel()">
              {{ "ONSIP_I18N.REVIEW_AND_SUBMIT" | translate }}
            </button>
            <button type="button" mat-stroked-button color="primary" (click)="backStep()">
              {{ "ONSIP_I18N.BACK" | translate }}
            </button>
            <button mat-button type="button" color="primary" (click)="handleCancel()">
              {{ "ONSIP_I18N.CANCEL" | translate }}
            </button>
          </div>
          }
        </div>
        }
      </mat-step>
      <!-- ng-template needs to be inside the stepper for template to work-->
      <ng-template #announcementBasicForm let-column>
        @if (!showEditPanel) {
        <div class="onsip-grid-placement basic-settings-form-container">
          <div class="column-1 basic-settings">
            <div class="name-prop">
              <div class="mat-body-1">{{ "ONSIP_I18N.ANNOUNCEMENT_NAME" | translate }}</div>
              <mat-form-field appearance="outline" class="form-field">
                <input
                  matInput
                  #announcementName
                  type="text"
                  formControlName="announcementName"
                  name="announcementName"
                  [attr.data-cy]="E2eLocators.ADMIN_ANNOUNCEMENT_ADD_NAME"
                />
                <mat-error>{{ getAnnouncementNameError() }}</mat-error>
              </mat-form-field>
            </div>
            <div class="transfer-prop">
              <div class="mat-body-1">{{ "ONSIP_I18N.TRANSFER_TO" | translate }}</div>
              <div class="form-field-width">
                <onsip-address-autocomplete
                  #transferUsername
                  formControlName="transferUsername"
                  [customOptions]="customOptions"
                  name="transferUsername"
                >
                </onsip-address-autocomplete>
              </div>
            </div>
            <div>
              <div class="mat-body-1">{{ "ONSIP_I18N.SIP_ADDRESS" | translate }}</div>
              <div class="form-field-width">
                <onsip-sip-address-field formControlName="sipAddress"> </onsip-sip-address-field>
              </div>
            </div>
            <div class="name-prop">
              <div class="mat-body-1 ext-header">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
              <div class="form-field-width">
                <onsip-extensions-list #extensionsList formControlName="extensions">
                </onsip-extensions-list>
              </div>
            </div>
          </div>
        </div>
        } @if (showEditPanel) {
        <div class="onsip-grid-placement review-edit-subsection">
          <div class="column-1 basic-settings">
            <div class="name-prop">
              <div class="mat-body-1">{{ "ONSIP_I18N.ANNOUNCEMENT_NAME" | translate }}</div>
              <mat-form-field appearance="outline" class="form-field">
                <input
                  matInput
                  #announcementName
                  type="text"
                  formControlName="announcementName"
                  name="announcementName"
                />
              </mat-form-field>
            </div>
            <div class="name-prop">
              <div class="mat-body-1">{{ "ONSIP_I18N.TRANSFER_TO" | translate }}</div>
              <div class="form-field">
                <onsip-address-autocomplete
                  #transferUsername
                  formControlName="transferUsername"
                  name="transferUsername"
                >
                </onsip-address-autocomplete>
              </div>
            </div>
            <div>
              <div class="mat-body-1">{{ "ONSIP_I18N.SIP_ADDRESS" | translate }}</div>
              <div class="form-field-width">
                <onsip-sip-address-field formControlName="sipAddress"> </onsip-sip-address-field>
              </div>
            </div>
            <div class="name-prop">
              <div class="mat-body-1 ext-header">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
              <div class="form-field-width">
                <onsip-extensions-list #extensionsList formControlName="extensions">
                </onsip-extensions-list>
              </div>
            </div>
            <div class="name-prop">
              <div class="mat-body-1 phone-header">
                {{ "ONSIP_I18N.PHONE_NUMBERS" | translate | sentenceCase }}
              </div>
              <div class="form-field-width">
                <onsip-phone-number-list
                  #phoneNumbers
                  formControlName="phoneNumbers"
                  (checkedNumbersEmitter)="phonesList = $event"
                  [userName]="announcementInfo.controls.sipAddress.value"
                  [aor]="currentAor"
                >
                </onsip-phone-number-list>
              </div>
            </div>
          </div>
        </div>
        }
      </ng-template>
      <ng-template #announcementCustomForm let-column>
        <div class="onsip-grid-placement">
          <div class="custom-column" [class.custom-announcements-form-container]="!showEditPanel">
            <div class="radio-button-container" [class.review-edit-subsection]="showEditPanel">
              <onsip-togglable-recorder
                formControlName="record"
                entityLabel="recording"
                [defaultType]="recordingType"
                (urlChange)="sanitizedAudioFile = $event"
                (recordingTypeChange)="recordingType = $event"
              >
              </onsip-togglable-recorder>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-horizontal-stepper>
  </form>
</onsip-loading-container>
<span class="mat-body-2 contact-support"
  >{{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
  <a class="support-link" [routerLink]="views.CONTACT_SUPPORT">
    {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
  </a>
</span>
